<template>
    <div id="app">
        <component :is="layout">
            <router-view></router-view>
        </component>
    </div>
</template>
<script>
    const defaultLayout = 'layout';
    export default {
        data() {
            return {
                authenticationTimeWatcherTimer: 0
            }
        },
        computed: {
            layout() {
                return this.$route.meta.layout || defaultLayout;
            }
        },
        methods: {
            initializeAuthenticationWatcher: function () {
                let self = this;
                this.authenticationTimeWatcherTimer = this.getTokenExpirationTimeLeft();
                setInterval(() => {
                    if (this.$store.getters.isAuthenticated == true) {
                        this.authenticationTimeWatcherTimer = this.getTokenExpirationTimeLeft();
                    }
                }, 60000);
            },
            getTokenExpirationTimeLeft: function () {
                return new Date((this.$store.getters.tokenExpiration - (new Date()).getTime() / 1000)).getTime();
            },
            validateAccessToken: function () {
                this.$store.dispatch("validateAccessToken")
                    .then(response => {
                        console.log("Access token has been validated.");
                    })
                    .catch(error => {
                        console.log("Access token check is not valid.");
                    });
            },
        },
        mounted: function () {
            this.validateAccessToken();
            this.initializeAuthenticationWatcher();
        },
        watch: {
            authenticationTimeWatcherTimer: function (value) {
                if (this.$store.getters.isAuthenticated == false) {
                    return;
                }

                if (value > 0 && value < 300) {
                    this.$store.dispatch("refreshToken")
                        .then(response => {
                            console.log("Token has been refreshed successfully.");
                        })
                        .catch(error => {

                        });
                }
                else if (value < 0) {
                    this.$store.dispatch("destroyTokens")
                        .then(response => {
                            console.log("Tokens has been destroyed.");
                        })
                        .catch(error => {

                        });
                }
            }
        },
    }</script>
<style lang="scss">
    @import "./../src/assets/scss/style";
    @import "~bootstrap/dist/css/bootstrap.css";
    
</style>
